import React from "react";
import { SideEntityController } from "../types";

export const SideEntityControllerContext = React.createContext<SideEntityController>({} as SideEntityController);
